import {axios_, doGetRequest, doPostRequest} from '@/tools/axios_';
import {getToken, Utils} from '@/tools/utils';
import {doDeleteRequest} from '../../../tools/axios_';

// 获取机构负责人
export const getCompanyManagerList = async (companyId) => {
  return await doGetRequest({
      url: '/api/organization/orgAgency/getCompanyManagerList',
      params: {
          companyId
      }
  });
}
// 获取商户是否开通渠道
export const getControlChannelRoots= async () => {
  return await doGetRequest({
      url: '/api/organization/orgCompanyChannel/getOrgIsOpenChannel'
  });
}

// 获取商户是否自媒体商户
export const getIsDepartmentOrg= async () => {
    return await doGetRequest({
        url: '/api/organization/orgCompanyDepartment/isDepartmentOrg'
    });
}

// 获取渠道列表
export const getChannelList = async () => {
    return await doGetRequest({
        url: '/api/organization/orgCompanyChannel/treeList',
        params: {
            companyId: Utils.getCompanyId(),
            companyLevelId: Utils.getCompanyLevelId()
        }
    })
}

// 获取渠道/机构的详情
export const getCompanyDetailById = async (companyId) => {
    return await doGetRequest({
        url: '/api/organization/orgCompany/getDetails',
        params: {companyId}
    })
}

// 删除渠道
export const deleteChannel = async (companyId) => {
    return await doDeleteRequest({
        url: '/api/organization/orgCompanyChannel/delete',
        params: {companyId}
    })
}

// 创建渠道
export const createChannel = async (data) => {
    return await doPostRequest({
        url: '/api/organization/orgCompanyChannel/save',
        data
    })
}

// 编辑渠道
export const editChannel = async (data) => {
    return await doPostRequest({
        url: '/api/organization/orgCompanyChannel/modify',
        data
    })
}

// 获取渠道的枚举值
export const getEnumFormList= async () => {
  return await doGetRequest({
      url: '/api/organization/orgInfo/crm/dic/list'
  });
}
// 获取指定编码用户数据权限
export const getUserPermissionInfoByCode  = async (data) => {
    return await doGetRequest({
        url: '/api/v2/system/get_user_permission_info_by_code',
        params: data
    });
}

export const getUserPermissionInfoByCodeNoBff  = async (data) => {
    return await doGetRequest({
        url: '/api/admin/merchantPlatform/user/getUserPermissionInfoByCode',
        params: {...data}
    });
}